import { useEffect } from 'react';
import { selectActiveFeedTab } from '../../store/dashboard/selectors';
import styles from './ActionsRequired.module.scss';
import { Feed } from './components/Chat/Feed';
import { Dashboard } from './components/Dashboard/Dashboard';
import { Button, RolePermissionChecker } from 'components';
import { useCreatePatient, useDevice } from 'hooks';
import { dashboardActions } from 'store/dashboard/slice';
import { asyncDashboardActions } from 'store/dashboard/thunks';
import { asyncPatientsActions } from 'store/patients/thunks';
import { useDispatch, useSelector } from 'store/utils';
import { UserRole } from 'types';

export const ActionsRequired = () => {
  const { openModalHandler } = useCreatePatient();
  const { isTablet } = useDevice();

  const activeFeedTab = useSelector(selectActiveFeedTab);

  const dispatch = useDispatch();

  useEffect(() => {
    const updateData = () => {
      if (document.visibilityState === 'visible') {
        dispatch(
          dashboardActions.resetDashboardCasesBeforeUpdate([
            'New',
            'Letter',
            'Finished',
            'InTreatment',
            'OutOfTreatment',
          ]),
        );

        dispatch(asyncDashboardActions.getPatientCasesDashboardNew());
        dispatch(asyncDashboardActions.getPatientCasesDashboardLetter());
        dispatch(asyncDashboardActions.getPatientCasesDashboardInTreatment());
        dispatch(asyncDashboardActions.getPatientCasesDashboardFinished());
        dispatch(asyncDashboardActions.getPatientCasesDashboardOutOfTreatment());

        dispatch(dashboardActions.getFeedMessagesAmount());
        dispatch(dashboardActions.getFeed(activeFeedTab));
      }
    };

    window.addEventListener('visibilitychange', updateData);

    return () => window.removeEventListener('visibilitychange', updateData);
  }, [dispatch, activeFeedTab]);

  const onOpenCreatePatientModalHandler = () => {
    openModalHandler();
  };

  return (
    <div className={styles.container}>
      {isTablet && (
        <RolePermissionChecker rolesAllowedToView={[UserRole.CLINIC]}>
          <div className={styles.newPatientControls}>
            <Button onClick={onOpenCreatePatientModalHandler} leftIcon="Plus" className={styles.newPatientButton}>
              Create patient
            </Button>
          </div>
        </RolePermissionChecker>
      )}
      <Dashboard />
      {isTablet && <div className={styles.divider} />}
      <Feed />
    </div>
  );
};
